module.exports = __webpack_public_path__ + "public/SiteIcons/hostStepIcons/photos.svg?da07822d";